import axios from 'axios';

const saleInstance = axios.create({
	baseURL: process.env.URL_SALES,
});

const notificationInstance = axios.create({
	baseURL: process.env.FORM_URL,
});

const productionInstance = axios.create({
	baseURL: process.env.PRODUCTION_URL,
});

const perInstance = axios.create({
	baseURL: process.env.URL_PER,
});

const apiInstance = axios.create({
	baseURL: process.env.API_DOCUMENT_VALIDATE,
});

export default function (Vue) {
	/* eslint-disable no-param-reassign */
	Vue.prototype.$httpSales = saleInstance;
	Vue.prototype.$httpNotification = notificationInstance;
	Vue.prototype.$httpProduction = productionInstance;
	Vue.prototype.$http = perInstance;
	Vue.prototype.$httpApi = apiInstance;
}



// WEBPACK FOOTER //
// ./src/axios.js